import React from "react";
import { useState } from "@vrf/fr-vrf-core-react";
import {
  RootComponentEditDialogContext,
  rootComponentEditDialogInitialState,
} from ".";

export const RootComponentEditDialogStateProvider = ({ children }: any) => {
  const [pageState, setPageState] = useState(
    rootComponentEditDialogInitialState,
  );
  const context = {
    pageState: pageState,
    setPageState: setPageState,
  };
  return (
    <RootComponentEditDialogContext.Provider value={context}>
      {children}
    </RootComponentEditDialogContext.Provider>
  );
};
